import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  LayoutDashboard,
  Ticket,
  MessageSquare,
  BookOpen,
  GraduationCap,
  BarChart3,
  Settings,
  LogOut,
  Phone,
  Zap,
  AlertCircle,
  Share2,
  TrendingUp,
  DollarSign,
  Cloud,
  LineChart,
  Wrench,
  Bot,
  Users,
  Mail,
  Image,
  Video,
  Calendar,
  Code2,
  Shield,
  Radar,
  Wifi,
  CheckSquare,
  FileText,
  History,
  ChevronDown,
  Lock,
  Briefcase,
  Package,
  ListTodo,
  User,
  AlertTriangle,
  Clock,
  Globe,
  Router,
  Eye,
  Brain,
  UserCheck,
  TrendingDown,
  Smile,
  Key,
  Award,
  ExternalLink,
  X,
} from 'lucide-react'
import { useAuthStore } from '../../store/authStore'
import clsx from 'clsx'

const menuSections = [
  {
    title: null,
    sectionIcon: null,
    items: [
      { path: '/ai-ceo', label: 'AI CEO Command Center', icon: Brain, badge: true, primary: true },
      { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, separator: false },
      { path: '/tools-showcase', label: 'All Tools Showcase', icon: BarChart3, badge: false, primary: false },
    ]
  },
  {
    title: 'HELP DESK COMMAND CENTER',
    sectionIcon: Wrench,
    items: [
      { path: '/control-center', label: 'AI Control Center', icon: AlertCircle, badge: true, primary: true },
      { path: '/itil-helpdesk', label: 'ITIL Help Desk', icon: Wrench, badge: true, primary: true },
      { path: '/channels', label: 'Channel Monitor', icon: MessageSquare },
      { path: '/tickets', label: 'Unified Queue', icon: Ticket },
      { path: '/chat', label: 'Chat', icon: MessageSquare },
      { path: '/knowledge-base', label: 'Knowledge Base', icon: BookOpen },
      { path: '/training', label: 'Student Questions', icon: GraduationCap },
      { path: '/call-logs', label: 'Call Logs', icon: Phone },
      { path: '/textnow-phone-config', label: 'TextNow Phone Config', icon: Phone, badge: true },
    ]
  },
  {
    title: 'CRM & SALES',
    sectionIcon: Briefcase,
    items: [
      { path: '/customer-sales', label: 'Customer Sales', icon: Briefcase, badge: true, primary: true },
    ]
  },
  {
    title: 'ACCOUNTS & INTEGRATIONS',
    sectionIcon: Key,
    items: [
      { path: '/accounts', label: 'Accounts & Integrations', icon: Key, badge: true, primary: true },
    ]
  },
  {
    title: 'INVENTORY & SUPPLY CHAIN',
    sectionIcon: Package,
    items: [
      { path: '/inventory-supply-chain', label: 'Inventory & Supply Chain', icon: Package, badge: true, primary: true },
    ]
  },
  {
    title: 'PROJECT & TASK MANAGEMENT',
    sectionIcon: ListTodo,
    items: [
      { path: '/project-management', label: 'Project & Task Management', icon: ListTodo, badge: true, primary: true },
    ]
  },
  {
    title: 'HR / PAYROLL / EMPLOYEES',
    sectionIcon: Users,
    items: [
      { path: '/hr-payroll', label: 'HR Dashboard', icon: User, badge: true, primary: true },
      { path: '/time-attendance', label: 'Time & Attendance', icon: Clock, badge: false },
      { path: '/payroll', label: 'Payroll Management', icon: DollarSign, badge: false },
      { path: '/leave-management', label: 'Leave Management', icon: Calendar, badge: false },
      { path: '/performance', label: 'Performance Reviews', icon: Award, badge: false },
      { path: '/benefits', label: 'Benefits', icon: CheckSquare, badge: false },
      { path: '/onboarding', label: 'Onboarding & Training', icon: GraduationCap, badge: false },
      { path: '/hr-analytics', label: 'HR Analytics', icon: BarChart3, badge: false },
    ]
  },
  {
    title: 'RECOVERY & COMPLIANCE',
    sectionIcon: AlertTriangle,
    items: [
      { path: '/recovery-compliance', label: 'Recovery & Compliance Plan', icon: AlertTriangle, badge: true, primary: true },
    ]
  },
  {
    title: 'CALENDAR & SCHEDULING',
    sectionIcon: Calendar,
    items: [
      { path: '/cybertection-calendar', label: 'Cybertection Calendar', icon: Calendar, badge: true, primary: true },
      { path: '/meetings', label: 'Meetings & Conferencing', icon: Video, badge: true, primary: true },
      { path: '/calendar', label: 'Calendar', icon: Calendar, badge: true, primary: true },
      { path: '/meeting-scheduler', label: 'Meeting Scheduler', icon: Clock, badge: true, primary: true },
    ]
  },
  {
    title: 'COMPANY GROWTH',
    sectionIcon: TrendingUp,
    items: [
      { path: '/company-growth', label: 'Company Growth Monitor', icon: LineChart, badge: true, primary: true },
    ]
  },
  {
    title: 'CLOUD',
    sectionIcon: Cloud,
    items: [
      { path: '/cloud-monitor', label: 'Cloud Monitor', icon: Cloud, badge: true, primary: true },
    ]
  },
  {
    title: 'SOCIAL MEDIA',
    sectionIcon: Share2,
    items: [
      { path: '/social-media', label: 'Social Media Manager', icon: Share2, badge: true, primary: true },
      { path: '/ai-auto-social-media', label: 'AI Auto Poster', icon: Zap, badge: true, primary: true },
      { path: '/social-media-comments', label: 'Comment Monitor', icon: MessageSquare, badge: true, primary: true },
    ]
  },
  {
    title: 'MARKETING',
    sectionIcon: TrendingUp,
    items: [
      { path: '/marketing-monitor', label: 'Marketing AI Monitor', icon: TrendingUp, badge: true, primary: true },
      { path: '/ai-marketing-assistant', label: 'AI Marketing Assistant', icon: Zap, badge: true, primary: true },
      { path: '/marketing-cost-tracker', label: 'Marketing Cost Tracker', icon: BarChart3, badge: true, primary: true },
    ]
  },
  {
    title: 'TRAINING CENTER HUB',
    sectionIcon: GraduationCap,
    items: [
      { path: '/bots/joe-bot', label: 'Joe Bot', icon: Bot, badge: true, primary: true },
      { path: '/bots/recruiter-bot', label: 'Recruiter Bot', icon: Users, badge: true, primary: true },
      { path: '/bots/onboard-bot', label: 'Onboard Bot', icon: BookOpen, badge: true, primary: true },
      { path: '/bots/email-bot', label: 'Email Bot', icon: Mail, badge: true, primary: true },
      { path: '/bots/media-bot', label: 'Media Bot', icon: Image, badge: true, primary: true },
      { path: '/bots/ceo-joe-bot', label: 'CEO Joe Bot', icon: AlertCircle, badge: true, primary: true },
      { path: '/bots/meeting-center', label: 'Meeting Center', icon: Calendar, badge: true, primary: true },
    ]
  },
  {
    title: 'AUDITOR',
    sectionIcon: CheckSquare,
    items: [
      { path: '/live-audit', label: 'Live Audit', icon: CheckSquare, badge: true, primary: true },
      { path: '/write-report', label: 'Write Report', icon: FileText, badge: true, primary: true },
      { path: '/audit-history', label: 'Audit History', icon: History, badge: true, primary: true },
      { path: '/audit-tool', label: 'Comprehensive Audit Tool', icon: BarChart3, badge: true, primary: true },
      { path: '/penetration-test', label: 'Penetration Testing', icon: Zap, badge: true, primary: true },
      { path: '/vulnerability-assessment', label: 'Vulnerability Assessment', icon: AlertTriangle, badge: true, primary: true },
      { path: '/dark-web-monitor', label: 'Dark Web Monitor', icon: Eye, badge: true, primary: true },
      { path: '/phishing-sim', label: 'Phishing Sim Tool', icon: Mail, badge: true, primary: true },
    ]
  },
  {
    title: 'FINANCIAL',
    sectionIcon: DollarSign,
    items: [
      { path: '/financial-monitor', label: 'Financial Monitor', icon: DollarSign, badge: true, primary: true },
      { path: '/tax-prep', label: 'Tax Prep', icon: FileText, badge: true, primary: true },
      { path: '/ai-financial-assist', label: 'AI Financial Assist', icon: Zap, badge: true, primary: true },
      { path: '/accounting-general-ledger', label: 'Accounting & General Ledger', icon: BarChart3, badge: true, primary: true },
      { path: '/quickbooks-xero', label: 'QuickBooks/Xero Integration', icon: DollarSign, badge: true, primary: true },
    ]
  },
  {
    title: 'DOCUMENT MANAGEMENT & COLLABORATION',
    sectionIcon: FileText,
    items: [
      { path: '/document-management', label: 'Document Storage & Sharing', icon: FileText, badge: true, primary: true },
      { path: '/doc-collaboration', label: 'Document Collaboration', icon: MessageSquare, badge: true, primary: true },
      { path: '/version-control', label: 'Version Control', icon: Code2, badge: true, primary: true },
      { path: '/drive-integration', label: 'Cloud Drive Integration', icon: Cloud, badge: true, primary: true },
    ]
  },
  {
    title: 'WEB BROWSER',
    sectionIcon: Globe,
    items: [
      { path: '/web-browser', label: 'Web Browser', icon: Globe, badge: true, primary: true },
    ]
  },
  {
    title: 'NETWORK',
    sectionIcon: Router,
    items: [
      { path: '/network', label: 'Network Management', icon: Router, badge: true, primary: true },
    ]
  },
  {
    title: 'IoT',
    sectionIcon: Wifi,
    items: [
      { path: '/iot', label: 'IoT Management', icon: Wifi, badge: true, primary: true },
    ]
  },
  {
    title: 'VISITOR MANAGEMENT',
    sectionIcon: UserCheck,
    items: [
      { path: '/visitor-management', label: 'Visitor Management', icon: UserCheck, badge: true, primary: true },
    ]
  },
  {
    title: 'COMPETITOR INTELLIGENCE',
    sectionIcon: TrendingDown,
    items: [
      { path: '/competitor-intelligence', label: 'Competitor Intelligence Bot', icon: TrendingDown, badge: true, primary: true },
    ]
  },
  {
    title: 'SENTIMENT ANALYSIS',
    sectionIcon: Smile,
    items: [
      { path: '/sentiment-analysis', label: 'Sentiment Analysis Engine', icon: Smile, badge: true, primary: true },
    ]
  },
  {
    title: 'SECURITY',
    sectionIcon: Shield,
    items: [
      { path: '/siem-tool', label: 'Cyber Strike', icon: Shield, badge: true, primary: true },
      { path: '/edr', label: 'EDR Tool', icon: Radar, badge: true, primary: true },
      { path: '/app-security', label: 'App Security', icon: Lock, badge: true, primary: true },
      { path: '/guardbot-integration', label: 'Guardbot Integration', icon: Wifi, badge: true, primary: true },
      { path: '/sandbox-analysis', label: 'Sandbox Analysis (Joe Box)', icon: AlertTriangle, badge: true, primary: true },
      { path: '/device-protection', label: 'Device Protection', icon: Shield, badge: true, primary: true },
    ]
  },
  {
    title: 'EMPLOYEES',
    sectionIcon: Users,
    items: [
      { path: '/employees', label: 'Employee Collaboration', icon: Users, badge: true, primary: true },
      { path: '/admin-access-control', label: 'Admin Control Panel', icon: Shield, badge: true, primary: true },
      { path: 'https://cybertection.work', label: 'Employee Portal (cybertection.work)', icon: ExternalLink, badge: true, external: true },
    ]
  },
  {
    title: 'ADMINISTRATION',
    sectionIcon: Settings,
    items: [
      { path: '/ai-settings', label: 'AI Control Center', icon: Brain, badge: true, primary: true },
      { path: '/ai-system-admin', label: 'AI System Admin', icon: Shield, badge: true, primary: true },
      { path: '/app-audit', label: 'App Audit', icon: Package, badge: true, primary: true },
      { path: '/developer-station', label: 'Developer Station', icon: Code2, badge: true, primary: true },
      { path: '/api-integration', label: 'API Integration', icon: Zap, badge: true, primary: true },
      { path: '/backend-automation', label: 'Backend Automation', icon: Zap, badge: true, primary: true },
      { path: '/comprehensive-analytics', label: 'Comprehensive Analytics', icon: BarChart3, badge: true, primary: true },
      { path: '/analytics', label: 'Analytics', icon: BarChart3 },
      { path: '/ai-config', label: 'AI Settings (Legacy)', icon: Zap },
      { path: '/settings', label: 'Settings', icon: Settings },
    ]
  },
]

export default function Sidebar({ onClose }) {
  const location = useLocation()
  const logout = useAuthStore((state) => state.logout)
  const user = useAuthStore((state) => state.user)

  // Initialize all sections as collapsed except Dashboard and Help Desk
  const [expandedSections, setExpandedSections] = useState({
    0: true,  // Dashboard (always visible)
    1: true,  // HELP DESK COMMAND CENTER (main feature)
    2: false, // CRM & SALES
    3: false, // ACCOUNTS & INTEGRATIONS
    4: false, // INVENTORY & SUPPLY CHAIN
    5: false, // PROJECT & TASK MANAGEMENT
    6: false, // HR / PAYROLL / EMPLOYEES
    7: false, // RECOVERY & COMPLIANCE
    8: false, // CALENDAR & SCHEDULING
    9: false, // COMPANY GROWTH
    10: false, // CLOUD
    11: false, // SOCIAL MEDIA
    12: false, // MARKETING
    13: false, // TRAINING CENTER HUB
    14: false, // AUDITOR
    15: false, // FINANCIAL
    16: false, // DOCUMENT MANAGEMENT & COLLABORATION
    17: false, // WEB BROWSER
    18: false, // NETWORK
    19: false, // IoT
    20: false, // VISITOR MANAGEMENT
    21: false, // COMPETITOR INTELLIGENCE
    22: false, // SENTIMENT ANALYSIS
    23: false, // SECURITY
    24: false, // EMPLOYEES
    25: false, // ADMINISTRATION
  })

  const toggleSection = (sectionIdx) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionIdx]: !prev[sectionIdx]
    }))
  }

  const handleLogout = () => {
    logout()
  }

  return (
    <div className="w-64 md:w-64 sm:w-56 bg-gradient-to-b from-slate-800 to-slate-900 border-r border-blue-500/30 flex flex-col shadow-2xl overflow-y-auto fixed left-0 top-0 h-screen z-40 md:relative md:h-auto md:top-auto md:left-auto md:z-auto">
      {/* Logo & Title */}
      <div className="p-6 border-b border-blue-500/20 sticky top-0 bg-gradient-to-b from-slate-800 to-slate-900 z-10">
        <div className="flex items-center space-x-3 justify-between">
          <div className="flex items-center space-x-3 flex-1 min-w-0">
            <img
              src="/logo.png"
              alt="Cybertection"
              className="w-12 h-12 rounded-lg shadow-lg shadow-blue-500/50 object-contain border border-blue-500/30 flex-shrink-0"
            />
            <div className="flex-1 min-w-0">
              <h1 className="text-sm font-black text-white truncate">Cybertection</h1>
              <p className="text-xs text-blue-400 truncate">Command Center</p>
            </div>
          </div>

          {/* Mobile Close Button */}
          {onClose && (
            <button
              onClick={onClose}
              className="md:hidden ml-2 p-2 hover:bg-slate-700 rounded-lg transition-colors text-blue-400 hover:text-blue-300 flex-shrink-0"
              title="Close Sidebar"
            >
              <X size={24} />
            </button>
          )}
        </div>
      </div>

      {/* Menu Sections */}
      <nav className="flex-1 p-4 space-y-0">
        {menuSections.map((section, sectionIdx) => (
          <div key={sectionIdx} className={`${sectionIdx > 0 ? 'mt-6 pt-6 border-t-2 border-blue-500/30' : ''}`}>
            {section.title && (
              <button
                onClick={() => toggleSection(sectionIdx)}
                className={`sidebar-section-header w-full px-4 py-3 mb-4 flex items-center gap-3 group rounded-lg transition-all border-2 font-bold uppercase text-xs tracking-widest ${
                  expandedSections[sectionIdx]
                    ? 'bg-gradient-to-r from-slate-800/90 to-slate-900/90 border-amber-500/60 shadow-lg shadow-amber-500/20'
                    : 'bg-slate-900/90 border-slate-700/70 hover:bg-slate-800/90 hover:border-amber-500/50'
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  {section.sectionIcon && (() => {
                    const SectionIcon = section.sectionIcon
                    return <SectionIcon size={20} className={`${expandedSections[sectionIdx] ? 'text-cyan-300' : 'text-white group-hover:text-cyan-300'} transition-colors`} />
                  })()}
                </div>
                <div className="flex-1 text-left">
                  <p className={`text-xs font-black uppercase tracking-widest transition-colors`} style={{ color: '#fbbf24' }}>
                    {section.title}
                  </p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  {!expandedSections[sectionIdx] && (
                    <span className={`text-xs font-black px-2.5 py-1 rounded-md text-white ${
                      section.items.filter(item => item.primary).length > 0
                        ? 'bg-gradient-to-r from-blue-600 to-cyan-500'
                        : 'bg-slate-700'
                    }`}>
                      {section.items.length}
                    </span>
                  )}
                  <ChevronDown
                    size={20}
                    className={`text-slate-400 group-hover:text-blue-400 transition-transform duration-300 flex-shrink-0 ${
                      expandedSections[sectionIdx] ? 'rotate-0 text-blue-300' : '-rotate-90'
                    }`}
                  />
                </div>
              </button>
            )}
            {(section.title === null || expandedSections[sectionIdx]) && (
              <div className={`space-y-2 ${section.title ? 'pl-3 pr-2 py-2 bg-blue-950/20 rounded-lg border-l-4 border-blue-500/50' : ''}`}>
                {section.items.map((item, itemIdx) => {
                  const Icon = item.icon
                  const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/')
                  const baseClassName = clsx(
                    'flex items-center space-x-3 px-4 py-2.5 rounded-lg font-semibold transition-all border text-sm',
                    isActive
                      ? item.primary
                        ? 'bg-gradient-to-r from-blue-600/50 to-cyan-600/50 text-blue-100 border-blue-500/60 shadow-lg shadow-blue-500/30'
                        : 'bg-blue-600/40 text-blue-100 border-blue-500/60 shadow-md shadow-blue-500/20'
                      : item.primary
                      ? 'text-blue-300 border-blue-500/20 hover:bg-gradient-to-r hover:from-blue-600/40 hover:to-cyan-600/40 hover:text-blue-100 hover:border-blue-500/40'
                      : 'text-slate-300 border-slate-700/40 hover:bg-blue-600/25 hover:text-blue-200 hover:border-blue-500/30'
                  )

                  return (
                    <div key={item.path}>
                      {item.external ? (
                        <a
                          href={item.path}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={baseClassName}
                        >
                          <Icon size={18} className="flex-shrink-0" />
                          <span className="flex-1">{item.label}</span>
                          {item.primary && item.badge && (
                            <span className="text-xs px-2 py-0.5 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-full font-black shadow-lg shadow-blue-500/50">PRO</span>
                          )}
                        </a>
                      ) : (
                        <Link
                          to={item.path}
                          className={baseClassName}
                        >
                          <Icon size={18} className="flex-shrink-0" />
                          <span className="flex-1">{item.label}</span>
                          {item.primary && item.badge && (
                            <span className="text-xs px-2 py-0.5 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-full font-black shadow-lg shadow-blue-500/50">PRO</span>
                          )}
                        </Link>
                      )}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* User Section */}
      <div className="p-4 border-t border-blue-500/20 space-y-3">
        <div className="flex items-center space-x-3 px-4 py-2">
          <img
            src={user?.avatar || 'https://ui-avatars.com/api/?name=User&background=0284c7&color=fff'}
            alt={user?.name}
            className="w-10 h-10 rounded-lg border border-blue-500/30"
          />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-white truncate">{user?.name}</p>
            <p className="text-xs text-blue-400 truncate">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="w-full flex items-center space-x-3 px-4 py-2 text-blue-300 hover:bg-blue-600/20 hover:text-blue-200 rounded-lg transition-all border border-blue-500/20 hover:border-blue-500/40"
        >
          <LogOut size={20} />
          <span className="text-sm font-semibold">Logout</span>
        </button>
      </div>
    </div>
  )
}
